import { ArrowDown, ArrowUp, Images, Plus, Trash2, Upload } from "lucide-react";
import { ekkoList } from "@/lib/ekkoDefaults";
import { Box, TextField, inputClass } from "./fields";

const MAX_IMAGES = 9;

// Separador "Galeria": fotos do espaço com descrição (para quem não vê a imagem e para o Google)
export default function GalleryTab({ content, setContent, onUpload }) {
  const images = ekkoList(content, "gallery_images");
  const save = (next) => setContent((prev) => ({ ...prev, gallery_images: next }));

  const update = (index, changes) => save(images.map((img, i) => (i === index ? { ...img, ...changes } : img)));
  const remove = (index) => save(images.filter((_, i) => i !== index));
  const move = (index, delta) => {
    const target = index + delta;
    if (target < 0 || target >= images.length) return;
    const next = [...images];
    [next[index], next[target]] = [next[target], next[index]];
    save(next);
  };

  return (
    <Box title="Galeria do espaço" icon={Images} hint="Fotos verticais ficam melhor (proporção 3:4). Guarda no fim.">
      <TextField label="Etiqueta (por cima do título)" field="gallery_eyebrow" content={content} setContent={setContent} />
      <TextField label="Título" field="gallery_title" content={content} setContent={setContent} />
      <TextField label="Subtítulo" field="gallery_subtitle" content={content} setContent={setContent} multiline rows={2} />

      <div className="grid md:grid-cols-2 gap-3">
        {images.map((img, i) => (
          <div key={i} className="flex gap-3 bg-[#141414] border border-[#3A3A3A] rounded p-2">
            <div className="w-20 h-28 flex-shrink-0 bg-[#1F1F1F] rounded overflow-hidden">
              {img.image && <img src={img.image} alt="" className="w-full h-full object-cover" />}
            </div>
            <div className="flex-1 min-w-0 space-y-2">
              <div className="flex gap-2">
                <label className="flex items-center gap-1 bg-[#3A3A3A] hover:bg-[#4A4A4A] text-[#F5F5F5] px-2 py-1 rounded cursor-pointer text-xs">
                  <Upload size={14} /> Imagem
                  <input type="file" accept="image/*" className="hidden" onChange={(e) => onUpload(e, (url) => update(i, { image: url }))} />
                </label>
                <button type="button" onClick={() => move(i, -1)} disabled={i === 0} className="text-[#A1A1AA] disabled:opacity-30" aria-label="Subir"><ArrowUp size={16} /></button>
                <button type="button" onClick={() => move(i, 1)} disabled={i === images.length - 1} className="text-[#A1A1AA] disabled:opacity-30" aria-label="Descer"><ArrowDown size={16} /></button>
                <button type="button" onClick={() => remove(i)} className="ml-auto text-red-400" aria-label="Remover"><Trash2 size={16} /></button>
              </div>
              <textarea
                rows={2}
                value={img.alt || ""}
                onChange={(e) => update(i, { alt: e.target.value })}
                placeholder="Descrição da foto (ex.: sala de treino com luz natural)"
                className={inputClass}
              />
            </div>
          </div>
        ))}
      </div>

      {images.length < MAX_IMAGES && (
        <button
          type="button"
          onClick={() => save([...images, { image: "", alt: "" }])}
          className="flex items-center gap-1 bg-[#3A3A3A] hover:bg-[#4A4A4A] text-[#F5F5F5] px-3 py-2 rounded text-sm"
        >
          <Plus size={16} /> Adicionar foto
        </button>
      )}
    </Box>
  );
}
